import React from "react";
import { Modal } from "react-bootstrap";

interface ConfirmCancelModalProps {
  show: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  message?: string;
}

const ConfirmCancelModal: React.FC<ConfirmCancelModalProps> = ({
  show,
  onConfirm,
  onCancel,
  title = "Confirm Action",
  message = "Are you sure you want to discard changes?"
}) => {
  return (
    <Modal
      show={show}
      onHide={onCancel}
      centered
      backdrop="static"
      style={{ backgroundColor: `rgba(0, 0, 0, 0.4)` }}
    >
      <Modal.Header closeButton>
        <Modal.Title>{title}</Modal.Title>
      </Modal.Header>

      <Modal.Body >
        <p className="mb-0">{message}</p>
      </Modal.Body>

      <Modal.Footer>
        <button
          className="btn add-btn"
          onClick={onCancel}
        >
          No
        </button>

        <button
          className="btn submit-btn"
          onClick={onConfirm}
        >
          Yes, Discard
        </button>
      </Modal.Footer>
    </Modal>
  );
};

export default ConfirmCancelModal;
